import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import { AccordionItem } from './DashboardAccordion';
import { Stat } from '@apps/admin/routes/DashboardPreview/components/DashboardChecklist/components/DashboardStats';

export const telemetryObject = createTelemetryObject({
  actions: {
    accordionDataLoaded: () => ({
      action: 'DashboardAccordionDataLoaded',
      category: 'DashboardAccordion'
    }),
    toggleAccordionItem: (isOpen: boolean, accordionId: AccordionItem['id']) => ({
      action: 'AccordionToggleButtonInteracted',
      category: 'DashboardAccordion',
      extraInfo: {
        accordionId,
        state: isOpen ? 'open' : 'close'
      }
    }),
    clickAccordionToggleBadge: (accordionId: AccordionItem['id']) => ({
      action: 'AccordionToggleBadgeInteracted',
      category: 'DashboardAccordion',
      extraInfo: {
        accordionId
      }
    }),
    clickPromoCardPrimaryCta: (accordionId: AccordionItem['id']) => ({
      action: 'PromoCardInteracted',
      category: 'DashboardAccordion',
      extraInfo: {
        accordionId,
        intent: 'primary'
      }
    }),
    clickPromoCardSecondaryCta: (accordionId: AccordionItem['id']) => ({
      action: 'PromoCardInteracted',
      category: 'DashboardAccordion',
      extraInfo: {
        accordionId,
        intent: 'secondary'
      }
    }),
    clickPromoCardDismiss: (accordionId: AccordionItem['id']) => ({
      action: 'PromoCardInteracted',
      category: 'DashboardAccordion',
      extraInfo: {
        accordionId,
        intent: 'dismiss'
      }
    }),
    clickAccordionMenuItem: (menuItemId: AccordionItem['accordionMenuItems'][number]['id']) => ({
      action: 'OpenPageClicked',
      category: 'DashboardAccordion',
      extraInfo: {
        menuItemId
      }
    }),
    clickAccordionStatusBadge: (accordionId: AccordionItem['id']) => ({
      action: 'AccordionStatusBadgeInteracted',
      category: 'DashboardAccordion',
      extraInfo: {
        accordionId
      }
    }),
    clickAccordionStat: (stat: Stat['id']) => ({
      action: 'AccordionStatInteracted',
      category: 'DashboardAccordion',
      extraInfo: {
        stat
      }
    })
  }
});

export const { useTelemetry: useDashboardAccordionTelemetry } = createTelemetry(telemetryObject);
